import { BoundaryChecker } from './model/BoundaryChecker';
import { ProgramQueue } from './model/ProgramQueue';
import { BoundaryListener } from './model/BoundaryListener';
import { ProgramInfo } from './model/ProgramInfo';
import { getEpochTime, getIsoString } from './HeartbeatUtils';
import { DefaultProgramInfo } from './model/DefaultProgramInfo';

export class BoundaryCheckerImpl implements BoundaryChecker {
  private programQueue: ProgramQueue = {};

  constructor(
    private readonly listener: BoundaryListener,
    currentProgram?: ProgramInfo,
  ) {
    if (!currentProgram) {
      return;
    }

    this.programQueue = {
      currentProgram: this.toDefaultProgramInfo(currentProgram),
    };
  }

  updateProgramTime(programInfo: ProgramInfo): void {
    const defaultProgramInfo = this.toDefaultProgramInfo(programInfo);

    if (!this.programQueue.currentProgram) {
      this.listener.boundaryChangeCallback(programInfo);
      this.programQueue.currentProgram = defaultProgramInfo;
    } else {
      if (defaultProgramInfo.programStartTime === this.programQueue.currentProgram.programStartTime) {
        return;
      }
      this.programQueue.nextProgram = defaultProgramInfo;
    }
  }

  playheadChange(playheadPosition: number): void {
    const currentProgramEndTime = this.programQueue?.currentProgram?.programEndTime;

    if (currentProgramEndTime && currentProgramEndTime <= playheadPosition) {
      this.programQueue.currentProgram = undefined;

      if (this.programQueue?.nextProgram) {
        this.programQueue.currentProgram = this.programQueue.nextProgram;
        this.programQueue.nextProgram = undefined;
        this.listener.boundaryChangeCallback(this.toProgramInfo(this.programQueue.currentProgram));
      } else {
        this.listener.boundaryChangeCallback();
      }
    }
  }

  private toDefaultProgramInfo(programInfo: ProgramInfo): DefaultProgramInfo {
    return {
      programId: programInfo.pgmId,
      programStartTime: getEpochTime(programInfo.pgmStartTime),
      programEndTime: getEpochTime(programInfo.pgmEndTime),
      isBlackout: programInfo.pgmBlackout ?? false,
      custom: programInfo.custom,
    };
  }

  private toProgramInfo(defaultProgramInfo: DefaultProgramInfo): ProgramInfo {
    return {
      pgmId: defaultProgramInfo.programId,
      pgmStartTime: getIsoString(defaultProgramInfo.programStartTime),
      pgmEndTime: getIsoString(defaultProgramInfo.programEndTime),
      pgmBlackout: defaultProgramInfo.isBlackout ?? false,
      custom: defaultProgramInfo.custom,
    };
  }
}
